export default "__VITE_ASSET__BdxmqB$2__"